import { UserCircleIcon, GearSixIcon, CaretRightIcon as ChevronRightIcon } from '@phosphor-icons/react';

const PhoneProfileMenu = ({ onScreenChange }) => {
  const menuItems = [
    {
      id: 'my-profile',
      label: 'My Profile',
      icon: UserCircleIcon,
      description: 'Manage your personal information and account details',
    },
    {
      id: 'quizr-settings',
      label: 'Settings',
      icon: GearSixIcon,
      description: 'Configure notifications and test preferences',
    },
  ];

  return (
    <div className="min-h-screen bg-[var(--q3-surface-default)] px-4 py-6">
      <div className="mb-4">
        <h1 className="text-2xl font-bold text-[var(--q3-neutral-default)] mb-2">Profile & Settings</h1>
        <div className="border-b border-[var(--q3-stroke-light)]" />
      </div>
      <div className="space-y-4">
        {menuItems.map((item) => (
          <button
            key={item.id}
            onClick={() => onScreenChange(item.id)}
            className="w-full flex items-center justify-between p-4 bg-[var(--q3-surface-default)] border border-[var(--q3-stroke-normal)] rounded-lg hover:bg-[var(--q3-surface-glass)] transition-colors"
          >
            <div className="flex items-center gap-3">
              <div className="p-2 bg-[var(--q3-surface-glass)] rounded-lg">
                <item.icon size={20} weight="regular" className="text-[var(--q3-neutral-default)]" />
              </div>
              <div className="text-left">
                <span className="font-medium text-[var(--q3-neutral-default)]">{item.label}</span>
              </div>
            </div>
            <ChevronRightIcon size={20} weight="regular" className="text-[var(--q3-neutral-light)]" />
          </button>
        ))}
      </div>
    </div>
  );
};

export default PhoneProfileMenu;
